export class SessionError extends Error {}